const mode = process.env.VUE_APP_CURRENTMODE;
let apiUrl = '',
  devUser = '',
  calendarUrl = '';

if (mode === 'production') {
  //正式环境
  apiUrl = 'https://task-ht.mingyuanyun.com';
  calendarUrl = 'https://mcalendar.mingyuanyun.com';
} else if (mode === 'test') {
  //测试环境
  apiUrl = 'https://env-2944-erp60.devops.mypaas.com';
  calendarUrl = 'https://mcalendar-test.mingyuanyun.com:10443';
} else {
  //开发环境
  calendarUrl = 'https://mcalendar-test.mingyuanyun.com:10443';
  // apiUrl = 'https://task-ht.mingyuanyun.com'; //正式
  // apiUrl = 'http://139.159.189.71:35032'; //rdc
   apiUrl = 'http://10.20.52.11:8082/'; //张杰
  // apiUrl = 'http://10.21.26.11:9999'; //江赛
  // apiUrl = 'https://env-2944-erp60.devops.mypaas.com'; // 测试
  // apiUrl = 'http://10.21.42.13:8234'; // 谢映辉



  //开发环境登录用户
  // devUser = 'ganhd';
  // devUser = 'jiangs66';
  // devUser = 'hupc01';
  // devUser = 'nil01';
  // devUser = 'wuy40';
  // devUser = 'xiegq';
  // devUser = 'changlj';
  // devUser = 'zhaoj08';
}

const config = {
  apiUrl,
  devUser,
  calendarUrl,
};

console.log(mode, JSON.stringify(config));

module.exports = config;
